import type { Attachment } from '@assistant-ui/react'

const IMAGE_FILENAME_PATTERN = /\.(avif|bmp|gif|heic|jpe?g|png|svg|tiff?|webp)$/i
const DOCUMENT_FILENAME_PATTERN = /\.(csv|doc|docx|md|pdf|rtf|tsv|txt|xls|xlsx)$/i

export function getDmpChatAttachmentType(contentType: string | undefined, filename: string): Attachment['type'] {
  const normalizedContentType = contentType?.toLowerCase()
  if (normalizedContentType?.startsWith('image/') || IMAGE_FILENAME_PATTERN.test(filename)) {
    return 'image'
  }

  const isDocument =
    normalizedContentType?.startsWith('text/') ||
    normalizedContentType?.includes('pdf') ||
    DOCUMENT_FILENAME_PATTERN.test(filename)

  return isDocument ? 'document' : 'file'
}
